import { Checkbox, Divider, FormControlLabel, Typography } from '@mui/material';
import React, { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FlexBox from '../../components/flexbox/flexbox';
import LanguageSelector from '../../components/language-selector/language-selector';
import { Company } from '../../api';
import useUpdateProfile from '../../data/profile/use-update-profile';

interface SystemSettingsSectionProps {
  profile: Company;
}

const SystemSettingsSection: React.FC<SystemSettingsSectionProps> = ({
  profile,
}) => {
  const { t } = useTranslation();
  const { mutate: updateProfile } = useUpdateProfile();
  const [withAllergensNotice, setWithAllergensNotice] = useState(
    !!profile?.labelCustomization?.enableIngredientLegend
  );
  const handleAllergensNoticeChange = (
    event: ChangeEvent<HTMLInputElement>
  ) => {
    setWithAllergensNotice(event.target.checked);
    updateProfile({
      data: {
        ...profile,
        labelCustomization: {
          ...(profile.labelCustomization || {}),
          enableIngredientLegend: event.target.checked,
        },
      },
    });
  };

  return (
    <>
      <FlexBox mx={2} flexDirection="column" gap={1}>
        <Typography sx={{ my: 1.5, ml: 0.5 }}>
          {t('settings.system-settings')}
        </Typography>
        <LanguageSelector variant="light" color="primary" />
        <FormControlLabel
          control={
            <Checkbox
              checked={withAllergensNotice}
              onChange={handleAllergensNoticeChange}
            />
          }
          label={t('settings.allergens-notice')}
          componentsProps={{ typography: { fontSize: 14, color: 'primary' } }}
        />
      </FlexBox>
      <Divider sx={{ my: 2 }} />
    </>
  );
};

export default SystemSettingsSection;
